import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss'],
    standalone: false
})
export class NavComponent {
    @Input() expand: boolean = false;
    @Output() setLayoutClass = new EventEmitter<void>();
    @Output() reloadPage = new EventEmitter<void>();

    constructor(private router: Router) { }

    public toggleMenu(): void {
        this.setLayoutClass.emit();
    }

    public goHome(): void {
        this.router.navigate(['/']);
    }
}
